import { useFeatureFlagEnabled } from "@posthog/react";
import type { ContentToolId } from "./tool-config";

export function useContentToolGates(): Record<ContentToolId, boolean> {
  const isMomentsFlag = useFeatureFlagEnabled("enable-moments") || import.meta.env.DEV;
  const isSwapsFlag = useFeatureFlagEnabled("enable-swaps") || import.meta.env.DEV;

  return {
    note: true,
    moment: isMomentsFlag === true,
    swap: isSwapsFlag === true,
  };
}
